import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Select from "react-select";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  SetVerifiedUserActions,
  SetTheSuperviorsListACtions,
  setTheSuperviorsgeteListActions,
  SetTheSuperviorsLisEmployeeeetACtions,
} from "../../../Redux/Slice";
import useDebouncedEffect from 'use-debounced-effect';

const Superviors = (props) => {
  const { show, setShow, EditID, client_id, old_employee, page , search } = props;

  const Swal = require("sweetalert2");
  const dispatch = useDispatch();
  const [EmpDAta, setEmpdatas] = useState([]);
  const state = useSelector((state) => state);
  const [PasChec, setPassChe] = useState({ cheque: true, passbook: false });
  const [Userlist, setUserList] = useState([]);
  const [Superviors, setSuperviors] = useState();
  const [OptionsSuperviors, setSuperviorsoptions] = useState([]);
  const [addstate, setAddState] = useState("add");
  const [SearchInputfields, setSearchInputfields] = useState();
  const [supervisorSearch , setSupervisorseachr] = useState("");
   const [SupervioursError , setsupervisourerr] = useState("")
   const [SearchDebounance, setSearchDebounance] = useState("");

  useEffect(() => {
    const payload = {
      search: supervisorSearch,
      page_size: 20,
      client_id: client_id,
      page: 1,
      old_employee: "",
      type: "add",
    };
    // console.log(e, "testnew")
    // dispatch(SetTheSuperviorsListACtions(payload));
    dispatch(SetTheSuperviorsLisEmployeeeetACtions(payload))
  }, [client_id ,supervisorSearch]);

  // useEffect(() => {
  //   if (state.SuperviorsSlice.SuperviorsData != undefined) {
  //     setEmpdatas(state.SuperviorsSlice.SuperviorsData);
  //     console.log(state.SuperviorsSlice.SuperviorsData, "VerifiedUsersData");
  //   }
  // }, [state.SuperviorsSlice.SuperviorsData]);

  useEffect(() => {
    if (state.SuperviorsEmployeee.SuperviorsEmployeeeData != undefined) {
      let ObjectArrayFormager = [];
      console.log(state.SuperviorsEmployeee.SuperviorsEmployeeeData, "sdfviwe fv9cq7gde");
      state.SuperviorsEmployeee.SuperviorsEmployeeeData.forEach((element) => {
        ObjectArrayFormager.push({
          value: element.user_id.id,
          label: `${element.user_id.first_name} ${element.user_id.user_uid ? `- ${element.user_id.user_uid}`:"" }`,
        });
      });

      setSuperviorsoptions(ObjectArrayFormager);
    }
  }, [state.SuperviorsEmployeee.SuperviorsEmployeeeData , supervisorSearch]);

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSupervisorseachr(SearchDebounance)
      }
    },
    500,
    [SearchDebounance]
  );
  const HandleInputChnages = (e) => {
    setSearchDebounance(e)
  };
  let USerIDliste = [];
  const HandleAddingChanges = (e) => {
    setSuperviors(e);
  };
  useEffect(() => {
    if (Superviors != [] && Superviors != null && Superviors != undefined) {
      Superviors.map((item) => {
        USerIDliste.push(item.value);
      });

      setUserList(USerIDliste);
    }
    else{
      setUserList([]);


    }

  }, [Superviors]);

  ////---PassBook-------or -------------cheque----changes---
  const handlePassBookChnages = (e, name, value, values) => {
    console.log(value, values, "values", name);

    setAddState(name);
    setPassChe({
      ...PasChec,
      cheque: value,
      passbook: values,
    });
  };
   
   
  const HandleClick = (e) => {
    // console.log(Userlist, "sdfsidi");
 var a = 0;
  if(Userlist.length == 0 || Userlist == undefined){
     a = 1;
     setsupervisourerr("*Supervior's is required")
  }
  if(a == 0){
    const payload = {
      data: {
        user_list: Userlist,
        type: addstate,
      },
      client_id: client_id,
      page: page,
      search:search
    };
    dispatch(setTheSuperviorsgeteListActions(payload, setShow(false)));
  }
  };

  return (
    <>
      <div className="Shift RoleCreatePopup">
        <div className="Shift ShiftCreatePopup">
          <div
            // className={`  ${stateDisplay ? " POPUP" : "outerPOPUP"}`}
            className="  BeforeSHIFTPopUp"
          >
            <div className=" BodyShiftContent  " style={{ width: "31%" , background:"transparent"}}>
              <div className="card">
                <div className="card-body cards ">
                  <div className="UserPoup">
                    <div className="BeforForms" style={{ width: "100%" }}>
                      <div className="Form" style={{ width: "100%" }}>
                        <div className="ModalHeader" style={{ width: "100%" , background:"rgb(35, 68, 146)", color:"#fff"}}>
                          <span>Supervior</span>
                          <div
                            className="CloseIcon"
                            onClick={(e) => setShow(false)}
                          >
                            <CloseOutlinedIcon />
                          </div>
                        </div>

                        <div className="Modal-Body">
                          <div className="row">
                            <div className="col-6 mt-4">
                              <label className="form-label">Employee 

                              <span style={{ color: "red" }}>*</span>

                              </label>
                              <Select
                                options={OptionsSuperviors}
                                onChange={(e) => {
                                  HandleAddingChanges(e);
                                  setsupervisourerr("")
                                }}
                                onInputChange={(e) => {
                                  HandleInputChnages(e);
                                }}
                                value={Superviors}
                                isMulti
                                 className="Selects"
                              />
                              <p className="Error">{SupervioursError}</p>
                            </div>
                          </div>

                          <div
                            className="UserButtons"
                            style={{ marginTop: "20px" }}
                          >
                            <button
                              class="btn  ButtonCSS SaveBtn"
                              type="submit"
                              onClick={(e) => {
                                HandleClick(e);
                              }}
                            >
                              Submit
                            </button>

                            <button
                              class="btn  ButtonCSS CancelBtn"
                              onClick={(e) => setShow(false)}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Superviors;
